import { Modal } from './Modal';
import { GLYPH_SHARE } from './shellNav';

/**
 * How to install on an iPhone or iPad. Safari has no install prompt, so the
 * three taps are written out; the Share glyph is drawn so the user knows which
 * button to look for.
 */
export function InstallHelpSheet({ onDismiss }: { onDismiss: () => void }) {
  return (
    <Modal title="Add Autopostmate to your home screen" onDismiss={onDismiss}>
      <ol className="install-steps">
        <li>
          Tap Share{' '}
          <span className="install-steps__glyph" aria-hidden="true">
            {GLYPH_SHARE}
          </span>{' '}
          in Safari. On an iPhone it is in the bar at the bottom, on an iPad at the top right.
        </li>
        <li>Scroll down and tap Add to Home Screen.</li>
        <li>Tap Add. Autopostmate opens from your home screen in its own window.</li>
      </ol>
    </Modal>
  );
}
